import { GetCountries } from '../../../../../../../types/ProjectManagement/Project/ProjectView/Invoices/CountryList/countryDetailstype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../../utils/apiUtils'
import { CountryApiConfig, AllowedHttpMethods } from '../../../../../apiList'

const addCountry = async (name: string): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CountryApiConfig.addCountry,
    method: AllowedHttpMethods.post,
    data: {
      name,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getcountries = async (): Promise<GetCountries[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CountryApiConfig.getCountries,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const deleteCountry = async (id: number): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CountryApiConfig.deleteCountry,
    method: AllowedHttpMethods.delete,
    params: { id },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const countryApi = {
  addCountry,
  getcountries,
  deleteCountry,
}

export default countryApi
